import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    attrs: {
      "fluid": ""
    }
  }, [_c('core-n20Card', {
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.imageSrc ? _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.reset'),
            "color": _vm.color,
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.imageSrc = null;
              _vm.rotatedImage = null;
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-undo")])], 1) : _vm._e(), _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.process'),
            "color": _vm.color,
            "disabled": !_vm.hasCompleteInfo,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": _vm.processOverlayImage
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-abacus")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.process')) + "\n      ")], 1), _c(VBtn, {
          class: `v-btn-x mx-1 bg-rounded-button-${_vm.color}`,
          attrs: {
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.publish'),
            "color": _vm.color,
            "disabled": !(_vm.processedInfo || {}).image,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('processed', _vm.processedInfo);
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-bullhorn")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.publish')) + "\n      ")], 1), _c(VBtn, {
          staticClass: "v-btn-x mx-1 v-btn--rounded bg-rounded-button-danger",
          attrs: {
            "color": "danger",
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('close');
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-times")])], 1)];
      },
      proxy: true
    }])
  }, [!_vm.imageSrc ? [_vm.twinImages.length > 0 ? _c(VRow, [_c(VSpacer), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VSelect, {
    attrs: {
      "items": _vm.twinImages,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayImage'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "item-value": "id",
      "item-text": "name",
      "hide-details": ""
    },
    on: {
      "change": _vm.overlayImageSelected
    },
    model: {
      value: _vm.overlayImageId,
      callback: function ($$v) {
        _vm.overlayImageId = $$v;
      },
      expression: "overlayImageId"
    }
  })], 1), _c(VSpacer)], 1) : _vm._e(), _c('p', {
    staticClass: "card-description",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.twinImages.length > 0 ? [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.or')))] : _vm._e(), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.dropzone')) + "\n      ")], 2), _c('div', {
    staticClass: "image-upload-wrapper",
    on: {
      "dragover": _vm.handleDragOver,
      "drop": _vm.onFileChange,
      "click": function ($event) {
        return _vm.$refs.attachmentInput.click();
      }
    }
  }, [_c('img', {
    staticClass: "image-upload-img",
    attrs: {
      "src": "img/niota-classic/placeholder.png"
    }
  }), _c('input', {
    ref: "attachmentInput",
    staticStyle: {
      "visibility": "hidden",
      "width": "0",
      "height": "0"
    },
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])] : _vm._e(), _vm.imageSrc ? _c('div', [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.map.overlayWizard.text'))
    }
  })])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    ref: "image-anchor-picker-container"
  }, [_c('core-dtwin-map-overlay-wizard-image-anchor-picker', {
    ref: "image-anchor-picker",
    staticStyle: {
      "height": "635px"
    },
    attrs: {
      "imageSrc": _vm.imageSrc,
      "width": _vm.anchorCanvasWidth,
      "height": 635
    },
    on: {
      "update-anchor1-position": _vm.updateAnchor1Position,
      "update-anchor2-position": _vm.updateAnchor2Position
    }
  })], 1)]), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('core-dtwin-map-overlay-wizard-geo-anchor-picker', {
    attrs: {
      "overlayInfo": _vm.overlayInfo,
      "addressObjectParam": _vm.addressObject
    },
    on: {
      "update-anchor1-coordinate": _vm.movedAnchor1Coordinate,
      "update-anchor2-coordinate": _vm.movedAnchor2Coordinate
    }
  })], 1)], 1), _vm.processedInfo.image ? [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.neLat'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: _vm.processedInfo.ne.lat,
      callback: function ($$v) {
        _vm.$set(_vm.processedInfo.ne, "lat", $$v);
      },
      expression: "processedInfo.ne.lat"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.neLon'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: _vm.processedInfo.ne.lon,
      callback: function ($$v) {
        _vm.$set(_vm.processedInfo.ne, "lon", $$v);
      },
      expression: "processedInfo.ne.lon"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.swLat'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: _vm.processedInfo.sw.lat,
      callback: function ($$v) {
        _vm.$set(_vm.processedInfo.sw, "lat", $$v);
      },
      expression: "processedInfo.sw.lat"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.map.swLon'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "required": "",
      "hide-details": "",
      "disabled": ""
    },
    model: {
      value: _vm.processedInfo.sw.lon,
      callback: function ($$v) {
        _vm.$set(_vm.processedInfo.sw, "lon", $$v);
      },
      expression: "processedInfo.sw.lon"
    }
  })], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "800px"
    },
    attrs: {
      "src": _vm.processedInfo.image
    }
  })])], 1)] : _vm._e()], 2) : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };